module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CENTER1"
  }, [_vm._v("Centre of Theology and Philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "CENTER2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(www.theologyphilosophycentre.co.uk)")])]), _vm._v(" "), _c('p', {
    staticClass: "SG2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Every doctrine which does not reach the one thing necessary, every separated philosophy, will remain deceived by false appearances. It will be a doctrine, it will not be Philosophy.")])]), _vm._v(" "), _c('p', {
    staticClass: "SC"
  }, [_vm._v("Maurice Blondel, 1861–1949")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("This book series is the product of the work carried out at the Centre of Theology and Philosophy (COTP), at the University of Nottingham.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The COTP is a research-led institution organized at the interstices of theology and philosophy. It is founded on the conviction that these two disciplines cannot be adequately understood or further developed, save with reference to each other. This is true in historical terms, since we cannot comprehend our Western cultural legacy unless we acknowledge the interaction of the Hebraic and Hellenic traditions. It is also true conceptually, since reasoning is not fully separable from faith and hope, or conceptual reflection from revelatory disclosure. The reverse also holds, in either case.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The Centre is concerned with:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "BL-1ST"
  }, [_vm._v("the historical interaction between theology and philosophy.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("the current relation between the two disciplines.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("attempts to overcome the analytic/continental divide in philosophy.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("the question of the status of “metaphysics”: Is the term used equivocally? Is it now at an end? Or have twentieth-century attempts to have a postmetaphysical philosophy themselves come to an end?")]), _vm._v(" "), _c('li', {
    staticClass: "BL-LAST"
  }, [_vm._v("the construction of a rich Catholic humanism."), _c('p', {
    staticClass: "TE _idGenParaOverride-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I am very glad to be associated with the endeavours of this extremely important Centre that helps to further work of enormous importance. Among its concerns is the question whether modernity is more an interim than a completion — an interim between a pre-­modernity in which the porosity between theology and philosophy was granted, perhaps taken for granted, and a postmodernity where their porosity must be unclogged and enacted anew. Through the work of leading theologians of international stature and philosophers whose writings bear on this porosity, the Centre offers an exciting forum to advance in diverse ways this challenging and entirely needful, and cutting-edge work.")])]), _c('p', {
    staticClass: "TC _idGenParaOverride-2"
  }, [_vm._v("Professor William Desmond, Leuven")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98714306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Oakes_A_Theology_of_Grace1.vue
// module id = 60
// module chunks = 0